// Base URL for MLB Stats API
const BASE_URL = "https://statsapi.mlb.com/api/v1";
const LIVE_BASE_URL = "https://statsapi.mlb.com/api/v1.1";

/**
 *  Get schedule + basic game data for a specific date
 * - Includes teams, score, inning, game status
 * - Use for main game list / scoreboard
 */

export const getSchedule = (date) =>
  `${BASE_URL}/schedule?sportId=1&date=${date}&hydrate=linescore,probablePitcher,team(division)`;

/**
 *  Get full live game data (VERY detailed)
 * - Use ONLY when a game is expanded
 */
export const getLiveGameFeed = (gamePk) =>
  `${LIVE_BASE_URL}/game/${gamePk}/feed/live`;

/**
 * Get boxscore for a game
 * - Lineups
 * - Batting + pitching stats
 * - Substitutions
 * - Good for expanded game view
 */
export const getBoxscore = (gamePk) => `${BASE_URL}/game/${gamePk}/boxscore`;

/**
 *  Get linescore for a game
 * - Inning-by-inning scoring
 * - Count (balls/strikes/outs)
 * - Good alternative to live feed if you want less data
 */
export const getLinescore = (gamePk) => `${BASE_URL}/game/${gamePk}/linescore`;

/**
 *  Get player season stats
 */
export const getPlayerStats = (playerId, type = "season") =>
  `${BASE_URL}/people/${playerId}/stats?stats=${type}`;

/**
 *  Get team roster
 */
export const getTeamRoster = (teamId) => `${BASE_URL}/teams/${teamId}/roster`;

/**
 *  Get team stats
 */
export const getTeamStats = (teamId) => `${BASE_URL}/teams/${teamId}/stats`;

/**
 * Get league standings
 */
export const getStandings = () =>
  `${BASE_URL}/standings?sportId=1&leagueId=103,104&standingsTypes=regularSeason&hydrate=league,division`;

/**
 *  Get all MLB teams
 * - Team IDs, names, abbreviations
 */
export const getTeams = () => `${BASE_URL}/teams`;

/**
 * 🎥 Get game content
 * - Highlights, recap videos, editorial content
 */
export const getGameContent = (gamePk) => `${BASE_URL}/game/${gamePk}/content`;

/**
 *  Get schedule with probable pitchers
 * - Adds starting pitcher info to schedule
 */
export const getScheduleWithPitchers = (date) =>
  `${BASE_URL}/schedule?date=${date}&hydrate=probablePitcher`;

export const getLeagueLeaders = ({
  category,
  statGroup = "hitting",
  limit = 10,
  season = new Date().getFullYear(),
  range = "season",
}) => {
  const params = new URLSearchParams({
    leaderCategories: category,
    statGroup,
    limit,
    sportId: 1,
  });

  if (range === "season") {
    params.set("season", season);
  }

  if (range === "last7" || range === "last30") {
    const days = range === "last7" ? 7 : 30;
    const end = new Date();
    const start = new Date();

    start.setDate(end.getDate() - days);

    params.set("statType", "byDateRange");
    params.set("startDate", start.toISOString().split("T")[0]);
    params.set("endDate", end.toISOString().split("T")[0]);
  }

  return `${BASE_URL}/stats/leaders?${params.toString()}`;
};
